import { useEffect, useState } from 'react';

/**
 * Hook que debouncea un valor
 * @param value - El valor a debouncer
 * @param delay - El tiempo de delay en milisegundos (por defecto 500ms)
 * @returns El valor debouncedo
 */
function useDebounce<T>(value: T, delay: number = 500): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}

export default useDebounce;
